import './card.global.css';

export const CardComponent = {
  template: '<ng-transclude></ng-transclude>',
  transclude: true,
};
